import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { AdminSetariComponent } from './admin-setari.component';
import { CronsComponent } from './crons/crons.component';
import { AddCronsComponent } from './crons/add-crons/add-crons.component';
import { EditCronsComponent } from './crons/edit-crons/edit-crons.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        AdminSetariComponent,
        CronsComponent,
        AddCronsComponent,
        EditCronsComponent,
    ],
    imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
    exports: [AdminSetariComponent],
})
export class AdminSetariModule { }